// extracted by mini-css-extract-plugin
export default {"root":"DjrfZ5WFDph3TcY1XXdR"};